module.exports = __webpack_public_path__ + "img/icey.7eb24093.png";